import React from 'react';
import { useSelector } from 'react-redux';

import {
  CustomNotification,
  dialogFunction,
  ButtonSmallIcon,
} from 'common/components';

import { Menu } from 'antd';

import { PlusCircleOutlined } from '@ant-design/icons';
import { ROUTE } from 'static/Constants';
import { useMutateCreateProductOverlay } from './queries';
import { useProductOverlaidList } from 'common/queries/product-module';
import { useDispatchReloadPage } from 'hooks/useReloadPage';

import { openNewTab } from 'utils/common/route';

import { Can } from 'context/Can';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

import selectorsGridView from 'common/components/grid-view/controllers/selectors';
import { sleep } from 'utils/delay';

const CreateProductOverlay = (props) => {
  const { productId, isProductFullView = false, productFull = null } = props;
  const reloadPage = useDispatchReloadPage();

  const handleCreateProductOverlay = useMutateCreateProductOverlay();
  const { isLoading } = handleCreateProductOverlay;

  const itemsSelection = useSelector(
    selectorsGridView.makeSelectDetailCurrentITemsSelection()
  );

  const { invalidateProductOverlaidList } = useProductOverlaidList(null, {
    enabled: false,
  });

  const onCreateProductOverlay = async () => {
    const params = {
      productItemId: productId,
    };

    await handleCreateProductOverlay.mutateAsync(params, {
      onSuccess: async (data) => {
        CustomNotification.success('Create Product overlay successfully');
        await sleep(1000);
        invalidateProductOverlaidList();
        reloadPage(true);
        dialogFunction({
          type: 'warn',
          content: `Do you want to open overlay product now?`,
          okText: 'Open',
          cancelText: 'Cancel',
          onOk: () => {
            openNewTab(ROUTE.PRODUCT + `/${data?.overlayProductId}`);
          },
        });
      },
      onError: (error) => {
        CustomNotification.error(error || 'Failed to Create Product Overlay');
      },
    });
  };

  const confirmCreateOverlay = () => {
    dialogFunction({
      type: 'warn',
      content: `Are you sure you want to create an overlay data for selected product?`,
      okText: 'OK',
      cancelText: 'Cancel',
      onOk: () => onCreateProductOverlay(),
    });
  };

  const isDisabled = (allowed) => {
    if (isProductFullView)
      return (
        !allowed ||
        productFull?.isOverlayProduct ||
        productFull?.isHaveOverlayForMember
      );

    return (
      !allowed ||
      itemsSelection?.length !== 1 ||
      itemsSelection?.[0]?.isOverlayProduct ||
      itemsSelection?.[0]?.isHaveOverlayForMember
    );
  };

  return (
    <Can
      I={ABILITY_ACTION.CREATE}
      a={ABILITY_SUBJECT.PRODUCT_OVERLAY}
      passThrough
    >
      {(allowed) => {
        const disabled = isDisabled(allowed);

        return (
          <>
            <Menu.Item
              style={{ backgroundColor: 'inherit' }}
              disabled={disabled}
            >
              <ButtonSmallIcon
                className='button-item-dropdown'
                icon={<PlusCircleOutlined />}
                label={'Create Product Overlay'}
                onClick={confirmCreateOverlay}
                disabled={disabled}
              />
            </Menu.Item>
          </>
        );
      }}
    </Can>
  );
};

export default CreateProductOverlay;
